module.exports = "/images/milano-16.jpg";